import type { PriceTypeType } from '@/api/hooks/useTenantConfig'
import { BBDTag } from '@gravitate-js/excalibrr'
import { Popover } from 'antd'
import _ from 'lodash'

export interface PriceTypesCellProps {
  priceTypes: PriceTypeType[] | null
  maxVisible?: number
}

export function PriceTypesCell({
  priceTypes,
  maxVisible = 2,
}: PriceTypesCellProps) {
  if (!priceTypes || priceTypes.length === 0) {
    // Blank reads as "settable, currently not set"
    return null
  }

  const renderTag = (priceType: PriceTypeType, index: number) => (
    <BBDTag key={index} theme2 style={{ margin: 0 }}>
      {_.startCase(priceType)}
    </BBDTag>
  )

  const visible = priceTypes.slice(0, maxVisible)
  const overflowCount = priceTypes.length - maxVisible

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px',
        alignItems: 'center',
        padding: '4px 0',
      }}
    >
      {visible.map((priceType, index) => renderTag(priceType, index))}
      {overflowCount > 0 && (
        <Popover
          content={
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
              {priceTypes.map((priceType, index) =>
                renderTag(priceType, index),
              )}
            </div>
          }
          title='Linked Price Types'
          trigger='click'
          placement='bottom'
        >
          <BBDTag
            theme2
            style={{ margin: 0, cursor: 'pointer', borderStyle: 'dashed' }}
          >
            +{overflowCount} more
          </BBDTag>
        </Popover>
      )}
    </div>
  )
}
